import { sendPixelTrackingWithSession } from '@core/tracking/senders/sendPixelTrackingWithSession'

import type { BackendExperiment } from './types'

const AB_TEST_TRACKING_ENDPOINT = '/trk/abtest:buckets'

/**
 * Track AB test buckets
 * @param experiments
 */
export const trackAbTest = (experiments: BackendExperiment[]) => {
  sendPixelTrackingWithSession({
    endpoint: {
      url: AB_TEST_TRACKING_ENDPOINT,
      isUserEngagement: false,
      consent: 'essential',
    },
    data: {
      event_properties: {
        experiments: experiments.map((exp) => ({
          _experiment_id: exp.experiment_id,
          variant_value: exp.variant_value,
          base_experiment_type: exp.base_experiment_type,
          name: exp.name,
        })),
      },
    },
    host: undefined,
  })
}
